"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function() {
        return Card;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCard = require("./useCard");
const _renderCard = require("./renderCard");
const _useCardStylesstyles = require("./useCardStyles.styles");
const _useCardContextValue = require("./useCardContextValue");
const Card = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCard.useCard_unstable)(props, ref);
    const cardContextValue = (0, _useCardContextValue.useCardContextValue)(state);
    (0, _useCardStylesstyles.useCardStyles_unstable)(state);
    return (0, _renderCard.renderCard_unstable)(state, cardContextValue);
});
Card.displayName = 'Card';
